import { IS_COUNTRY } from "../constants/countries"

export const openChat = () => {
  if (IS_COUNTRY.AR) {
    window.Reamaze?.popup()
  } else {
    window.fcWidget?.open()
  }
}
